import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

// import { JwtService } from './jwt.service';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ApiService {
    httpOptions: any = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    constructor(
        private http: HttpClient,
        // private jwtService: JwtService
    ) { }

    private formatErrors(error: any) {
        return throwError(error.error);
    }

    get(path: string, params: HttpParams = new HttpParams()): Observable<any> {
        return this.http.get(`${environment.apiRoot}${path}`, { params })
            .pipe(catchError(this.formatErrors));
    }

    

    getInd(path: string): Observable<any> {
        return this.http.get(`${environment.apiRoot}${path}`)
            .pipe(catchError(this.formatErrors));
    }
    
    put(path: string, body: Object = {}): Observable<any> {
        return this.http.put(
            `${environment.apiRoot}${path}`,
            JSON.stringify(body)
            , this.httpOptions
        ).pipe(catchError(this.formatErrors));
    }

    post(path: string, body: any): Observable<any> {


        return this.http.post(
            `${environment.apiRoot}${path}`,
            JSON.stringify(body)
            , this.httpOptions
        ).pipe(catchError(this.formatErrors));
    }

    delete(path): Observable<any> {
        return this.http.delete(
            `${environment.apiRoot}${path}`
        ).pipe(catchError(this.formatErrors));
    }

    downloadBlob(path: string,userFileName:string) {
        this.http.get(`${environment.apiRoot}${path}`, { observe: 'response', responseType: "blob" })
            .subscribe(res => {
                console.log(userFileName);
                var newBlob = new Blob([res.body], { type: res.headers.get('Content-Type') });
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(newBlob);
               // link.download = res.headers.get('FileName');
               link.download = userFileName;
                link.click();
            }, error => {
                catchError(this.formatErrors);
            });
      
    }


    downloadOpenPDF(path: string) {
        this.http.get(`${environment.apiRoot}${path}`, { observe: 'response', responseType: "blob" })
            .subscribe(res => {
                var newBlob = new Blob([res.body], { type: res.headers.get('Content-Type') });
                const fileURL = URL.createObjectURL(newBlob);
                window.open(fileURL, '_blank');
            }, error => {
                catchError(this.formatErrors);
            });
    }

    postAuth(path: string, body): Observable<any> {

        let headers = new HttpHeaders();
        headers = headers.set('Content-Type', 'application/x-www-form-urlencoded');
        headers = headers.set('Accept', 'application/x-www-form-urlencoded');
        let bodydata = `username=${body.userName}&password=${body.password}&companyProfileId=${body.companyProfileId}`;

        return this.http.post(
            `${environment.authRoot}${path}`, bodydata, { headers: headers }
        ).pipe(catchError(this.formatErrors));
    }
}
